<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> OOI /
          ตัวชี้วัดความสำเร็จ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text mb-5">
            1. ตัวชี้วัดความสำเร็จ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex flex-column  gap-16">
            <!--   OOI   -->
     
            <div v-for="(item, i) in masterData.kpi_masters" :key="i">
              <div  class="d-flex align-center flex-nowrap" style="gap: 1rem;">
                <span v-if="item.prefix_flag" class="mb-3 black--text txt-bigger">
                    {{ item.name }}
                  </span>
                  <div v-else class="mb-3 black--text txt-bigger" style='width: max-content;'>
                    ตัวชี้วัดที่ {{ item.no }} {{ item.name }}
                  </div>
           
                  <div v-if="item.no === '63' || item.no === '69'" class="d-flex align-center "
                      style="transform:  translateY(-6px);cursor: pointer;justify-content: center;background-color: var(--theme-color-one);width:max-content;border-radius: 999px; padding: 3px 2px 3px 3px;"
                      @click="syncKpi()"
                  >
                    <Icon
                      style="color: #ffffff"
                      class="font-24"
                      icon="mdi-light:refresh"
                    />
                  </div>
              </div>
              <div class="mb-3 txt-bigger potential-link" @click="goToTCCL()" v-if="item.no === '63' || item.no === '69' && tccl_full_url" >
                การประเมินบนระบบpotential tech
              </div>
              <OOILineField v-for="(sub, ind) in item.kpi_sub_masters" :key="ind" :label="sub.name" :unit="sub.unit"
                :kpiData="kpiData"
                :id="sub?.no"
                :url="tccl_full_url"
                :desc_flag="sub.desc_flag" :desc_label="sub.desc_label"
                :desc_value="kpi[sub.id] ? kpi[sub.id].description : null"
                :readonly="sub.disabled_on_submit_flag === 1 ? true : false" :field="sub.disabled_on_submit_flag === 1
                  ? calculateKPITotal(item)
                  : kpi[sub.id]
                    ? kpi[sub.id].kpi_sub_value
                    : ''
                  "
                :labelTextClass="setKpiFieldStyle(item.no, sub.no)"
                @onChange="setKpiField(sub.id, $event)" @onFocusOut="checkLessThanBefore(sub.id)"
                @onDescChange="setKpiDescription(sub.id, $event)"></OOILineField>

              <!--              <OOILineField-->
              <!--                  label="รวม"-->
              <!--                  :readonly="true"-->
              <!--                  :field="Object.values(kpi).map(x => x.kpi_sub_amount).reduce((a, b) => a + b, 0)"-->
              <!--              ></OOILineField>-->
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!------------------------------------- STI -------------------------------------------------->
    <!-- 2. ผลลัพธ์ที่ได้จากโครงการ (Outcome) -->
    <divcard v-if="masterData.plan_master.plan_code && masterData.plan_master.plan_code === 'STI'">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            2. ผลลัพธ์ที่ได้จากโครงการ (Outcome)
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <TextArea theme="3" height="120" :value="form.result_quantity"
                @onChange="setFormField('result_quantity', $event)"></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <TextArea theme="3" height="120" :value="form.result_quality"
                @onChange="setFormField('result_quality', $event)"></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>
    <!-- 3. จำนวนผู้ประกอบการที่สำเร็จการบ่มเพาะ -->
    <divcard
      v-if="masterData.plan_master.plan_code && masterData.plan_master.plan_code === 'STI' && (masterData.form_c.project_section_general_info.activity === '1' && isFinal)">
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          3. จำนวนผู้ประกอบการที่สำเร็จการบ่มเพาะ
        </div>

        <Button theme="6" @onClick="addCompanyList">
          + เพิ่มปีที่เข้าร่วมการบ่มเพาะ
        </Button>
      </div>

      <div class="card-part mt-5 pt-0">
        <div>
          <v-layout class="mt-3" v-for="(company, f) in companyList" :key="f">
            <v-flex xs3 class="mr-8">
              <div class="mb-1 black--text">ปีผู้ประกอบการที่เข้าร่วมบ่มเพาะ (พ.ศ.)</div>
              <v-text-field v-model="company.participants_year" :id="'participants_year' + f" placeholder="โปรดระบุ"
                outlined hide-details height="36" style="border-radius: 30px"
                @change="addToCompany(f, 'participants_year', $event)"></v-text-field>
            </v-flex>
            <v-flex xs3>
              <div class="mb-1 black--text">จำนวน (ราย)</div>
              <v-text-field v-model="company.participants_count" :id="'participants_count' + f" placeholder="โปรดระบุ"
                input-type="decimal" outlined hide-details height="36" style="border-radius: 30px"
                @change="addToCompany(f, 'participants_count', $event)"></v-text-field>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn depressed height="35" width="35" style="top:25px" fab dark color="#FD0C0C"
                @click="removeCompany(f)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </divcard>
    <!-- 3.SI 4.PF ตารางสรุปผู้ประกอบการที่อยู่ระหว่างกระบวนบ่มเพาะธุรกิจ วทน. (ตั้งแต่ปีเก่า - ปีปัจจุบัน) -->
    <divcard
      v-if="masterData?.plan_master?.plan_code === 'STI' && masterData.form_c.project_section_general_info.activity === '1'">
      <v-layout justify-space-between align-center>
        <v-flex shrink>
          <div class="mb-3 black--text txt-head">
            {{ isFinal ? '4.' : '3.' }}ตารางสรุปผู้ประกอบการที่อยู่ระหว่างกระบวนบ่มเพาะธุรกิจ วทน.
            <span class="font-14 font-w-400">(ตั้งแต่ปีเก่า - ปีปัจจุบัน)</span>
          </div>
        </v-flex>
        <v-flex shrink>
          <Button theme="500" class="mb-3" @onClick="is_incubation_company_form = true">
            + เพิ่มปีงบประมาณ
          </Button>
        </v-flex>
      </v-layout>

      <!-- header table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th width="10%" class="font-14 font-w-400 text-center" style="border-bottom: 0px">
                ปีงบประมาณ
              </th>
              <th width="15%" class="font-14 font-w-400 text-center" style="border-bottom: 0px">
                จัดการ
              </th>
              <th width="5%" class="font-14 font-w-400 text-center" style="border-bottom: 0px">
                ลำดับ
              </th>
              <th width="15%" class="font-14 font-w-400" style="border-bottom: 0px">
                ชื่อมหาวิทยาลัย
              </th>
              <th width="15%" class="font-14 font-w-400" style="border-bottom: 0px">
                ผลิตภัณฑ์
              </th>
              <th width="15%" class="font-14 font-w-400" style="border-bottom: 0px">
                เอกชน
              </th>
              <th width="15%" class="font-14 font-w-400" style="border-bottom: 0px">
                ประเภทเทคโนโลยี
              </th>
              <th width="10%" class="font-14 font-w-400 text-center" style="border-bottom: 0px">
                สถานะ
              </th>
            </tr>
          </thead>
        </template>
      </v-simple-table>

      <!-- body table -->
      <div v-if="incubation_companies.length > 0">
        <v-card v-for="(
incubation_companie, incubation_companie_index
          ) in incubation_companies" :key="incubation_companie_index" class="mb-4"
          style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, index) in incubation_companie[1]" :key="index">
                  <td width="10%" class="text-center" style="border-bottom: 0px">
                    <span v-if="index == 0">{{ incubation_companie[0] }}</span>
                  </td>
                  <td width="15%" class="text-center" style="border-bottom: 0px">
                    <v-btn icon @click="
                      editIncubationCompany(incubation_companie_index, index)
                      ">
                      <v-icon color="#F15A29"> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn icon @click="
                      deleteIncubationCompany(
                        incubation_companie_index,
                        index
                      )
                      ">
                      <v-icon color="#B1B1B1"> mdi-delete </v-icon>
                    </v-btn>
                  </td>
                  <td width="5%" class="text-center" style="border-bottom: 0px">
                    {{ index + 1 }}
                  </td>
                  <td width="15%" style="border-bottom: 0px">
                    {{ item.university_name }}
                  </td>
                  <td width="15%" style="border-bottom: 0px">
                    {{ item.product }}
                  </td>
                  <td width="15%" style="border-bottom: 0px">
                    {{ item.company }}
                  </td>
                  <td width="15%" style="border-bottom: 0px">
                    {{ item.technology_type === 'อุตสาหกรรมอื่น (ระบุ)' ? item.technology_type_other :
                      item.technology_type }}
                  </td>
                  <td width="10%" class="text-center" style="border-bottom: 0px">
                    {{ item.status }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>

        <!-- {{ incubationCompanyMainIndex }} : {{ incubationCompanySubIndex }} -->
      </div>

      <div v-else>
        <v-card class="mb-4" style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a">
          <div class="text-center py-4">ไม่มีข้อมูล</div>
        </v-card>
      </div>

      <v-divider />

      <v-form class="mt-6 incubation_companie_form" ref="incubation_company_form" v-model="valid_incubation_company"
        lazy-validation v-if="is_incubation_company_form">
        <div class="mb-3">
          <v-icon> mdi-pencil </v-icon>
          เพิ่ม
        </div>

        <v-row>
          <v-col cols="4">
            <label>ปีงบประมาณ (พ.ศ.)</label>
            <v-autocomplete v-model="incubation_companie_form.fiscal_year" :items="yearList" outlined color="#F15A29"
              rounded :rules="[(v) => !!v || 'กรุณาระบุปีงบประมาณ']" clearable
              @click:clear="incubation_companie_form.fiscal_year = ''"></v-autocomplete>
          </v-col>
          <v-col cols="8">
            <label>ชื่อมหาวิทยาลัย</label>
            <v-autocomplete v-model="incubation_companie_form.university_id" :items="university_masters"
              item-text="name_th" item-value="id" outlined color="#D3D3D3" rounded
              :rules="[(v) => !!v || 'กรุณาระบุชื่อมหาวิทยาลัย']" clearable @change="getUniversityName"
              @click:clear="incubation_companie_form.university_id = ''"></v-autocomplete>
          </v-col>
        </v-row>

        <label>ผลิตภัณฑ์</label>
        <v-textarea v-model="incubation_companie_form.product" outlined dense rows="5" color="#D3D3D3"
          style="border-radius: 30px" placeholder="โปรดระบุ" :rules="[(v) => !!v || 'กรุณาระบุผลิตภัณฑ์']"
          required></v-textarea>

        <v-row>
          <v-col cols="3">
            <label>เอกชน</label>
            <v-text-field v-model="incubation_companie_form.company" outlined color="#D3D3D3" rounded
              :rules="[(v) => !!v || 'กรุณาระบุปีงบประมาณ']"></v-text-field>
          </v-col>
          <v-col cols="3">
            <label>ประเภทอุตสาหกรรม</label>
            <v-autocomplete v-model="incubation_companie_form.technology_type" :items="company_masters" outlined
              color="#D3D3D3" rounded :rules="[(v) => !!v || 'กรุณาระบุชื่ออุตสาหกรรม']" clearable
              @click:clear="incubation_companie_form.technology_type = ''"></v-autocomplete>
          </v-col>
          <v-col v-if="incubation_companie_form.technology_type === 'อุตสาหกรรมอื่น (ระบุ)'" cols="3">
            <label>อื่นๆ ระบุ</label>
            <v-text-field v-model="incubation_companie_form.technology_type_other" outlined height="40"
              background-color="#fff" color="#F7941D" style="border-radius: 30px" placeholder="ระบุประเภทอุตสาหกรรม"
              :rules="[(v) => !!v || 'กรุณาระบุประเภทอุตสาหกรรม']" required></v-text-field>
          </v-col>
          <v-col cols="3">
            <label>สถานะ</label>
            <v-autocomplete v-model="incubation_companie_form.status" :items="status_masters" outlined color="#D3D3D3"
              rounded :rules="[(v) => !!v || 'กรุณาระบุชื่อมหาวิทยาลัย']" clearable
              @click:clear="incubation_companie_form.status = ''"></v-autocomplete>
          </v-col>
        </v-row>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="clearIncubationCompanyForm">
            ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="handleSubmitIncubationCompanyForm">
            ยืนยัน
          </Button>
        </div>
      </v-form>

      <!-- Form เพิ่มปีงบประมาณ -->

    </divcard>
    <!-- 4.SI 5.PF ภาคผนวก -->
    <divcard
      v-if="masterData.plan_master.plan_code &&
        masterData.plan_master.plan_code === 'STI' &&
        (masterData.form_c.project_section_general_info.activity === '1' || (masterData.form_c.project_section_general_info.activity === '2' && isFinal))">
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          {{ masterData.form_c.project_section_general_info.activity === '1' && !isFinal ? '4' :
            masterData.form_c.project_section_general_info.activity === '1' && isFinal ? '5' : '4' }}. ภาคผนวก
        </div>

        <Button theme="6" @onClick="addAnnexFile">
          + เพิ่มไฟล์
        </Button>
      </div>

      <div class="card-part mt-5 pt-0">
        <div>
          <div class="font-type-bold mb-1">
            รายละเอียดผู้ประกอบการที่อยู่ระหว่างกระบวนการบ่มเพาะธุรกิจ วทน.
          </div>
          <v-layout class="mt-3" v-for="(file, f) in annexFiles" :key="f">
            <v-flex xs7>
              <v-file-input v-model="annexFiles[f]" :id="'file' + f" :rules="rulesFile" color="#F15A29"
                :clearable="false" style="border-radius: 30px" outlined height="36" placeholder="" prepend-icon=""
                accept="application/pdf,.doc,.docx" v-show="checkValType(file.file_name) == 'object' ||
                  file.file_name == '' ||
                  file.file_name == null
                  " @change="addToAttachment(f, $event)"></v-file-input>
              <v-text-field v-show="checkValType(file.file_name) == 'string'" v-model="file.file_name" outlined
                height="36" color="#F15A29" style="border-radius: 30px" readonly></v-text-field>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn depressed dark rounded width="100" color="#464647" @click="selectFile(f)">
                <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                <span class="font-12 font-w-700">อัพโหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn depressed height="35" width="35" fab dark color="#FD0C0C" @click="removeFile(f)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </divcard>

    <!------------------------------------- SP -------------------------------------------------->
    <!-- 2. ผลลัพธ์ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'SP'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">2. ผลลัพธ์</div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <Wysiwyg theme="3" height="120" :value="form.result_quantity"
                @onChange="setFormField('result_quantity', $event)"></Wysiwyg>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <Wysiwyg theme="3" height="120" :value="form.result_quality"
                @onChange="setFormField('result_quality', $event)"></Wysiwyg>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- 3. ผลผลิตและตัวชี้วัดความสำเร็จ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'SP'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            3. ผลผลิตและตัวชี้วัดความสำเร็จ
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">ในเชิงเศรษฐกิจ</div>
              <TextArea theme="3" height="120" :value="form.kpi_eco"
                @onChange="setFormField('kpi_eco', $event)"></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">ในเชิงสังคม</div>
              <TextArea theme="3" height="120" :value="form.kpi_social"
                @onChange="setFormField('kpi_social', $event)"></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- 4. ผลกระทบ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'SP'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">4. ผลกระทบ</div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                เชิงปริมาณ/เชิงเศรษฐกิจของภูมิภาค
              </div>
              <Wysiwyg theme="3" height="120" :value="form.impact_quantity"
                @onChange="setFormField('impact_quantity', $event)"></Wysiwyg>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ/เชิงสังคม</div>
              <Wysiwyg theme="3" height="120" :value="form.impact_quality"
                @onChange="setFormField('impact_quality', $event)"></Wysiwyg>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- 5. ภาคผนวก -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'SP'
    ">
      <div class="txt-head black--text d-flex justify-space-between">
        <div>5. ภาคผนวก</div>

        <Button theme="6" @onClick="addAnnexFile"> + เพิ่มไฟล์ </Button>
      </div>

      <div class="card-part mt-5 pt-0">
        <div>
          <div class="font-type-bold mb-1">
            รายละเอียดของแต่ละห้องปฏิบัติการที่จะขอรับการสนับสนุนงบประมาณ
          </div>
          <v-layout class="mt-3" v-for="(file, f) in annexFiles" :key="f">
            <v-flex xs7>
              <v-file-input v-model="annexFiles[f]" :id="'file' + f" :rules="rulesFile" color="#F15A29"
                :clearable="false" style="border-radius: 30px" outlined height="36" placeholder="" prepend-icon=""
                accept="application/pdf,.doc,.docx" v-show="checkValType(file.file_name) == 'object' ||
                  file.file_name == '' ||
                  file.file_name == null
                  " @change="addToAttachment(f, $event)"></v-file-input>
              <v-text-field v-show="checkValType(file.file_name) == 'string'" v-model="file.file_name" outlined
                height="36" color="#F15A29" style="border-radius: 30px" readonly></v-text-field>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn depressed dark rounded width="100" color="#464647" @click="selectFile(f)">
                <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                <span class="font-12 font-w-700">อัพโหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn depressed height="35" width="35" fab dark color="#FD0C0C" @click="removeFile(f)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </divcard>

    <!------------------------------------- CR -------------------------------------------------->

    <!-- 2. ผลผลิตและตัวชี้วัดความสำเร็จ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'CR'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            2. ผลผลิตและตัวชี้วัดความสำเร็จ
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">ในเชิงเศรษฐกิจ</div>
              <TextArea theme="3" height="120" :value="form.s4_p2_eco"
                @onChange="setFormField('s4_p2_eco', $event)"></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">ในเชิงสังคม (ถ้ามี)</div>
              <TextArea theme="3" height="120" :value="form.s4_p2_social"
                @onChange="setFormField('s4_p2_social', $event)"></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>
    <!-- 3. ผลลัพธ์ที่ได้จากโครงการ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'CR'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">3. ผลลัพธ์ที่ได้จากโครงการ</div>

          <Wysiwyg theme="3" height="120" :value="form.s4_p3_result" @onChange="setFormField('s4_p3_result', $event)">
          </Wysiwyg>
        </div>
      </div>
    </divcard>
    <!-- 4. ผลกระทบ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'CR'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">4. ผลกระทบ</div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ/เชิงสังคม</div>
              <Wysiwyg theme="3" height="120" :value="form.s4_p4_quantity"
                @onChange="setFormField('s4_p4_quantity', $event)"></Wysiwyg>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ/เชิงเศรษฐกิจของภูมิภาค</div>
              <Wysiwyg theme="3" height="120" :value="form.s4_p4_quality"
                @onChange="setFormField('s4_p4_quality', $event)">
              </Wysiwyg>
            </div>
          </div>
        </div>
      </div>
    </divcard>
    <!-- 5. ประโยชน์ที่ได้รับ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'CR'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            5. ประโยชน์ที่ได้รับ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <Wysiwyg theme="3" height="120" :value="form.s4_p5_quality"
                @onChange="setFormField('s4_p5_quality', $event)">
              </Wysiwyg>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <Wysiwyg theme="3" height="120" :value="form.s4_p5_quantity"
                @onChange="setFormField('s4_p5_quantity', $event)"></Wysiwyg>
            </div>
          </div>
        </div>
      </div>
    </divcard>


    <!------------------------------------- IRTC -------------------------------------------------->
    <!-- 2. ผลลัพธ์ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'IRTC'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            2. ผลลัพธ์
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <TextArea theme="3" height="120" :value="form.s4_p3_quantity"
                @onChange="setFormField('s4_p3_quantity', $event)"></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <TextArea theme="3" height="120" :value="form.s4_p3_quality"
                @onChange="setFormField('s4_p3_quality', $event)"></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- 3. ประโยชน์ที่ได้รับ -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'IRTC'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            3. ประโยชน์ที่ได้รับ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <TextArea theme="3" height="120" :value="form.s4_p4_quantity"
                @onChange="setFormField('s4_p4_quantity', $event)"></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <TextArea theme="3" height="120" :value="form.s4_p4_quality"
                @onChange="setFormField('s4_p4_quality', $event)"></TextArea>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="mb-3 txt-bigger black--text">
          การประเมินผลกระทบด้านเศรษฐกิจ
          <span class="theme-color-seven">(โปรดกรอกข้อมูล เพื่อใช้ในการพิจารณาโครงการ)</span>
        </div>

        <div>
          <div class="d-flex gap-16 mb-5">
            <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
            <div class="flex xs3 txt-bigger text-center">
              ประมาณมูลค่า (บาท)
            </div>
            <div class="flex txt-bigger text-center">
              คาดการณ์ผลกระทบที่เกิดขึ้น
            </div>
          </div>
          <ul>
            <li>
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ยอดขายรายได้เฉลี่ย/การเพิ่มขึ้นยอดขายของผลิตภัณฑ์ กำไร (บาท)
                </div>
                <div class="flex xs3">
                  <TextField theme="3" input-type="decimal" isFormat :value="form.s4_p4_revenue"
                    @onChange="setFormField('s4_p4_revenue', $event)"></TextField>
                </div>
                <div class="flex">
                  <TextField theme="3" :value="form.s4_p4_revenue_desc"
                    @onChange="setFormField('s4_p4_revenue_desc', $event)"></TextField>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ต้นทุนการบริการบริหารจัดการ ทรัพยากรในองค์กรค่าใช้จ่ายการ ผลิต
                  ค่าใช้จ่ายอื่นๆ การจ้างงาน(คน) มูลค่าการจ้างงาน(บาท) การลดค่า
                  ใช้จ่าย ลดต้นทุนในการผลิต
                </div>
                <div class="flex xs3">
                  <TextField theme="3" input-type="decimal" isFormat :value="form.s4_p4_mgm_cost"
                    @onChange="setFormField('s4_p4_mgm_cost', $event)"></TextField>
                </div>
                <div class="flex">
                  <TextField theme="3" :value="form.s4_p4_mgm_cost_desc"
                    @onChange="setFormField('s4_p4_mgm_cost_desc', $event)"></TextField>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ประสิทธิภาพ/กำลังการผลิต การ เพิ่มกำลังการผลิต(บาท) มูลค่าของ
                  การเพิ่มประสิทธิภาพหรือคุณภาพ ของผลิตภัณฑ์(บาท)
                </div>
                <div class="flex xs3">
                  <TextField theme="3" input-type="decimal" isFormat :value="form.s4_p4_prod_cap"
                    @onChange="setFormField('s4_p4_prod_cap', $event)"></TextField>
                </div>
                <div class="flex">
                  <TextField theme="3" :value="form.s4_p4_prod_cap_desc"
                    @onChange="setFormField('s4_p4_prod_cap_desc', $event)"></TextField>
                </div>
              </div>
            </li>
            <li>
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  การลงทุน มูลค่าการลงทุน R&D (บาท) จำนวนผลิตภัณฑ์ใหม่ที่เสนอ
                  ขายในตลาดต่อปี
                </div>
                <div class="flex xs3">
                  <TextField theme="3" input-type="decimal" isFormat :value="form.s4_p4_investment"
                    @onChange="setFormField('s4_p4_investment', $event)"></TextField>
                </div>
                <div class="flex">
                  <TextField theme="3" :value="form.s4_p4_investment_desc"
                    @onChange="setFormField('s4_p4_investment_desc', $event)"></TextField>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex gap-16 mb-5">
          <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
          <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
          <div class="flex txt-bigger text-center">
            คาดการณ์ผลกระทบที่เกิดขึ้น
          </div>
        </div>
        <div class="d-flex gap-16">
          <div style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)">
            การประเมินผลกระทบด้านสังคม (จ้างคนในพื้นที่, วัตถุดิบท้องถิ่น)
          </div>
          <div class="flex xs3">
            <TextField theme="3" input-type="decimal" isFormat :value="form.s4_p4_social_impact_eval"
              @onChange="setFormField('s4_p4_social_impact_eval', $event)"></TextField>
          </div>
          <div class="flex">
            <TextField theme="3" :value="form.s4_p4_social_impact_eval_desc"
              @onChange="setFormField('s4_p4_social_impact_eval_desc', $event)"></TextField>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex gap-16 mb-5">
          <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
          <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
          <div class="flex txt-bigger text-center">
            คาดการณ์ผลกระทบที่เกิดขึ้น
          </div>
        </div>
        <div class="d-flex gap-16">
          <div style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)">
            การประเมินผลกระทบด้าน วิทยาศาสตร์และเทคโนโลยี (มีเครื่องจักร,
            ลิขสิทธิ์, งานวิจัย ต่อยอด)
          </div>
          <div class="flex xs3">
            <TextField theme="3" input-type="decimal" isFormat :value="form.s4_p4_sci_tech_impact_eval"
              @onChange="setFormField('s4_p4_sci_tech_impact_eval', $event)"></TextField>
          </div>
          <div class="flex">
            <TextField theme="3" :value="form.s4_p4_sci_tech_impact_eval_desc" @onChange="
              setFormField('s4_p4_sci_tech_impact_eval_desc', $event)
              "></TextField>
          </div>
        </div>
      </div>
    </divcard>

    <!-- 4. หากไม่ได้เข้ารับบริการกับทางอุทยานวิทยาศาสตร์ภูมิภาค -->
    <divcard v-if="
      masterData.plan_master.plan_code &&
      masterData.plan_master.plan_code === 'IRTC'
    ">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">
              4. หากไม่ได้เข้ารับบริการกับทางอุทยานวิทยาศาสตร์ภูมิภาค
              จะเกิดผลกระทบ/ผลเสียหายอย่างไร ท่านจะไปใช้บริการกับหน่วยงานใด
            </span>
          </div>
          <TextArea theme="3" height="120" :value="form.s4_p5_opinion"
            @onChange="setFormField('s4_p5_opinion', $event)"></TextArea>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import OOILineField from "../../../components/OOILineField";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import Wysiwyg from "@/components/input/Wysiwyg.vue";
import Button from "@/components/input/Button.vue";
import { Icon } from "@iconify/vue2";
export default {
  name: "CFormOOI",
  components: {
    Button,    
    Icon,
    Wysiwyg,
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    OOILineField,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {},
      kpi: {},
      plan_code: "",
      kpiSynced: false,
      OOIs: [
        {
          kpi_id: 60,
          kpi_name: "จำนวนผู้เข้าร่วมโครงการ IRTC ต่อปี",
          sub: [
            {
              kpi_sub_name: "มีผู้เข้าร่วมโครงการ IRTC ประเภทนิติบุคคล",
            },
          ],
        },
        {
          kpi_id: 61,
          kpi_name:
            "ผลกระทบเชิงเศรษฐกิจรวมที่เกิดขึ้นจาก IRTC ที่สามารถคำนวณได้ในปี",
          sub: [
            {
              kpi_sub_name: "มูลค่าของการเพิ่มกำลังการผลิต",
            },
            {
              kpi_sub_name: "มูลค่าของการลดต้นทุนในการผลิต",
            },
            {
              kpi_sub_name:
                "มูลค่าของการเพิ่มประสิทธิภาพหรือคุณภาพของผลิตภัณฑ์",
            },
            {
              kpi_sub_name:
                "มูลค่ายอดขายของผลิตภัณฑ์ที่เกิดขึ้นจริงหลังเข้าโครงการ",
            },
            {
              kpi_sub_name: "มูลค่าของกระบวนการผลิตใหม่ที่มีการผลิตจริง",
            },
          ],
        },
        {
          kpi_id: 62,
          kpi_name: "มูลค่าการลงทุน R&D ของผู้ประกอบการ IRTC ต่อปี",
          sub: [
            {
              kpi_sub_name: "ค่าใช้จ่ายที่เป็นเงินสด (in cash) ของโครงการ IRTC",
            },
            {
              kpi_sub_name:
                "ค่าใช้จ่ายที่เกี่ยวกับเครื่องมืออุปกรณ์วิจัยพัฒนาที่ใช้ในโครงการ",
            },
            {
              kpi_sub_name:
                "ค่าใช้จ่ายในการจัดทำหรือปรับปรุงสถานที่เพื่อดำเนินโครงการ",
            },
            {
              kpi_sub_name: "ค่าใช้จ่ายในการจ้างบุคลากรวิจัยรวมในปีที่ประเมิน",
            },
          ],
        },
        {
          kpi_id: 63,
          kpi_name:
            "คะแนนเฉลี่ยของระดับของเทคโนโลยีที่ผู้ประกอบการ IRTC นำมาใช้",
          sub: [
            {
              kpi_sub_name: "ระดับความสามารถของเทคโนโลยี (Functionality)",
            },
            {
              kpi_sub_name:
                "ระดับความก้าวหน้าของเทคโนโลยี (Newness, Advancement and Trend)",
            },
            {
              kpi_sub_name: "ระดับความง่ายในการใช้เทคโนโลยี (Usability)",
            },
            {
              kpi_sub_name:
                "ระดับการปรับขนาดไปสู่การผลิตเชิงพาณิชย์ (Scalability)",
            },
            {
              kpi_sub_name:
                "ระดับความสามารถในการแข่งขันของเทคโนโลยี (Competitiveness)",
            },
          ],
        },
      ],
      annexFiles: [],
      companyList: [],
      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) =>
          !value || value.size <= 50000000 || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],

      // incubation_companies
      is_incubation_company_form: false,
      incubation_companies: [],
      valid_incubation_company: true,
      university_masters: [],
      company_masters: [
        "อุตสาหกรรมยานยนต์สมัยใหม่ (Next-generation Automotive)",
        "อุตสาหกรรมอิเล็กทรอนิกส์อัจฉริยะ (Smart Electronics)",
        "อุตสาหกรรมการท่องเที่ยวกลุ่มรายได้ดีและการท่องเที่ยวเชิงสุขภาพ (Affluent, Medical and Wellness Tourism)",
        "การเกษตรและเทคโนโลยีชีวภาพ (Agriculture and Biotechnology)",
        "อุตสาหกรรมการแปรรูปอาหาร (Food for the Future)",
        "อุตสาหกรรมหุ่นยนต์ (Robotics)",
        "อุตสาหกรรมการบินและโลจิสติกส์ (Aviation and Logistics)",
        "อุตสาหกรรมเชื้อเพลิงชีวภาพและเคมีชีวภาพ (Biofuels and Biochemicals)",
        "อุตสาหกรรมดิจิตอล (Digital)",
        "อุตสาหกรรมการแพทย์ครบวงจร (Medical Hub)",
        "อุตสาหกรรมอื่น (ระบุ)"
      ],
      status_masters: [
        "บ่มเพาะธุระกิจ วทน. ปีที่ 1",
        "บ่มเพาะธุระกิจ วทน. ปีที่ 2",
        "บ่มเพาะธุระกิจ วทน. ปีที่ 3",
      ],
      incubation_companie_form: {
        fiscal_year: "",
        university_id: "",
        university_name: "",
        product: "",
        company: "",
        technology_type: "",
        technology_type_other: "",
        status: "",
      },
      incubationCompanyMainIndex: null,
      incubationCompanyIndex: null,
      syncId: null,
      tccl_full_url: null,
      kpiData: null
    };
  },
  computed: {
    ...mapState({
      OOIForm: (state) => state.CForm.OOIForm,
    }),
    total: function () {
      return this.calculateKPITotal();
    },
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
    yearList() {
      let year = new Date().getFullYear();
      let yearList = [];
      year = year + 543;
      for (let i = 0; i < 10; i++) {
        yearList.push(year - i);
      }
      return yearList;
    },
  },
  created() {
    if (this.isSameId && !this.masterData.form_c) this.form = this.OOIForm;
    if (this.masterData.form_c) {
      this.setData()
    }
    eventBus.$on("cFormOOI", () => {
      eventBus.$emit("cFormOOISend", {
        ...this.form,
        attachments: this.annexFiles || [],
        completed_incubation_company: this.companyList || [],
        incubation_companies: this.flattenNestedArray(this.incubation_companies) || [],
        kpi_sub_values: Object.values(this.kpi),
      });
    });

    eventBus.$on("cFormOOISetData", () => this.setData());

    this.university_masters = this.masterData.university_masters;
    this.syncId = this.masterData.form_c.id ;
    this.tccl_full_url = this.masterData?.tccl_full_url ;

    // this.groupIncubationCompany(data);
  },
  methods: {
    getUniversityName() {
      const university = this.university_masters.find(
        (x) => x.id === this.incubation_companie_form.university_id
      );
      this.incubation_companie_form.university_name = university
        ? university.name_th
        : "";
    },

    clearIncubationCompanyForm() {
      this.incubation_companie_form = {
        fiscal_year: "",
        university_id: "",
        university_name: "",
        product: "",
        company: "",
        technology_type: "",
        technology_type_other: "",
        status: "",
      };
      this.incubationCompanyMainIndex = null;
      this.incubationCompanySubIndex = null;
      this.is_incubation_company_form = false;
    },

    handleSubmitIncubationCompanyForm() {
      if (this.$refs.incubation_company_form.validate()) {
        if (
          this.incubationCompanyMainIndex != null &&
          this.incubationCompanySubIndex != null
        ) {
          this.updateIncubationCompany();
        } else {
          this.saveIncubationCompany();
        }
      }
    },

    saveIncubationCompany() {
      // เพิ่มข้อมูลใน array ของ incubation_companies ตามปีที่เลือก
      const index = this.incubation_companies.findIndex((e) => {
        return e[0] == this.incubation_companie_form.fiscal_year;
      });

      if (index === -1) {
        // ไม่เจอปีที่เลือกใน array ให้เพิ่มปีนั้นเข้าไป
        this.incubation_companies.push([
          this.incubation_companie_form.fiscal_year,
          [this.incubation_companie_form],
        ]);
      } else {
        // ถ้าเจอปีที่เลือกใน array ให้เพิ่มข้อมูลในปีนั้น
        this.incubation_companies[index][1].push(this.incubation_companie_form);
      }

      // เรียงข้อมูลใหม่ จากมากไปน้อย เช่น 2566, 2565
      this.incubation_companies.sort((a, b) => b[0] - a[0]);

      // ล้างข้อมูลใน form
      this.clearIncubationCompanyForm();
    },

    updateIncubationCompany() {

      // แก้ไขข้อมูลใน array ของ incubation_companies ตามปีที่เลือก
      this.incubation_companies[this.incubationCompanyMainIndex][1][
        this.incubationCompanySubIndex
      ] = this.incubation_companie_form;

      // เรียงข้อมูลใหม่ จากมากไปน้อย เช่น 2566, 2565
      this.incubation_companies.sort((a, b) => b[0] - a[0]);

      // ล้างข้อมูลใน form
      this.clearIncubationCompanyForm();
    },
    unflattenArray(input) {
      const output = [];

      for (const obj of input) {
        const fiscalYear = obj.fiscal_year;
        let yearGroup = output.find((group) => group[0] === fiscalYear);

        if (!yearGroup) {
          yearGroup = [fiscalYear, []];
          output.push(yearGroup);
        }

        yearGroup[1].push(obj);
      }

      return output;
    },
    flattenNestedArray(input) {
      const output = [];

      for (const item of input) {
        for (const obj of item[1]) {
          output.push(obj);
        }
      }

      return output;
    },
    editIncubationCompany(mainIndex, subIndex) {
      this.incubationCompanyMainIndex = mainIndex;
      this.incubationCompanySubIndex = subIndex;
      this.incubation_companie_form = this.incubation_companies[mainIndex][1][subIndex];
      this.incubation_companie_form.fiscal_year = this.incubation_companie_form.fiscal_year ? parseInt(this.incubation_companie_form.fiscal_year) : null
      this.is_incubation_company_form = true;
    },

    deleteIncubationCompany(mainIndex, subIndex) {
      this.incubation_companies[mainIndex][1].splice(subIndex, 1);

      // เช็คว่าถ้าข้อมูลในปีนั้นเป็นค่าว่างหมด ให้ลบปีนั้นออก
      if (this.incubation_companies[mainIndex][1].length === 0) {
        this.incubation_companies.splice(mainIndex, 1);
      }
    },

    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setData() {
      this.form = this.masterData.form_c.project_section;
      for (const x of this.masterData.kpi_masters) {
        for (const y of x.kpi_sub_masters) {
          if (y.kpi_sub_values) {
            let subId = y.kpi_sub_values.kpi_sub_master_id.toString();
            this.kpi[subId] = {};
            this.kpi[subId].id = y.kpi_sub_values.id;
            this.kpi[subId].kpi_sub_master_id =
              y.kpi_sub_values.kpi_sub_master_id;
            this.kpi[subId].kpi_sub_value = y.kpi_sub_values.kpi_sub_value;
            this.kpi[subId].description = y.kpi_sub_values.description;
          }
        }
      }
      this.plan_code = this.masterData.plan_master.plan_code
      if (this.plan_code === 'STI') {
        this.companyList = this.masterData.form_c.completed_incubation_company || []
        this.incubation_companies = this.masterData.form_c.incubation_companies ? this.unflattenArray(this.masterData.form_c.incubation_companies) : []
      }
      if (this.plan_code === 'CR') {
        this.form.s4_p2_eco = this.masterData.form_c.project_section.s4_p2_eco
        this.form.s4_p2_social = this.masterData.form_c.project_section.s4_p2_social
        this.form.s4_p3_result = this.masterData.form_c.project_section.s4_p3_result
        this.form.s4_p4_quantity = this.masterData.form_c.project_section.s4_p4_quantity
        this.form.s4_p4_quality = this.masterData.form_c.project_section.s4_p4_quality
        this.form.s4_p5_quality = this.masterData.form_c.project_section.s4_p5_quality
        this.form.s4_p5_quantity = this.masterData.form_c.project_section.s4_p5_quantity
      }
      if ((this.plan_code === 'SP' || this.plan_code === 'STI') && this.masterData.form_c.attachments) {
        this.annexFiles = this.masterData.form_c.attachments.filter(x => x.doc_type === 'annex')
      }

    },
    setKpiField(subId, val) {
      // format {
      //   kpi_sub_master_id: '',
      //   kpi_sub_value: ''
      // }
      // this.kpi[subId] = {}
      if (!this.kpi[subId]) this.kpi[subId] = {};
      this.kpi[subId].kpi_sub_master_id = subId;
      this.kpi[subId].kpi_sub_value = val;
      this.$forceUpdate();
    },
    checkLessThanBefore(subId) {
      if (this.isFinal && (this.$route.query.id || this.masterData.updateId)) {
        // progress/final and update case
        let oldVal = this.masterData.form_c.kpi_sub_values_inception?.find(
          (x) => x.kpi_sub_master_id == subId
        )?.kpi_sub_value;
        if (oldVal && this.kpi[subId].kpi_sub_value < oldVal) {
          this.kpi[subId].kpi_sub_value = oldVal;
          console.log(
            "Cannot input less than before, value has been rollback."
          );
          this.$forceUpdate();
        }
      }
    },
    setKpiDescription(subId, val) {
      if (!this.kpi[subId]) this.kpi[subId] = {};
      this.kpi[subId].description = val;
      this.$forceUpdate();
    },
    // Calculate sum by each KPI item
    calculateKPITotal: function (item) {
      let itemTotal = 0;
      switch (item.no) {
        case "26":
        case "28":
        case "32":
        case "34":
        case "43":
        case "47":
        case "49":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value) /
                    Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value)).toFixed(2);
              }
            }
          }
          break;
        case "27":
        case "33":
        case "46":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value) /
                    Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) * 100).toFixed(2);
              }
            }
          }
          break;
        case "51":
        case "64":
        case "70":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  ((Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) *
                    100) /
                  Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value)).toFixed(2);
              }
            }
          }
          break;
        case "54":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value == 0 
              || this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) *
                  Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value)* 12);
              }
            }
          }
          break;
        case "57":
        case "59":
        case "71":
        case "79":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value) /
                    Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value)).toFixed(2);
              }
            }
          }
          break;
        case "58":
          if (item.kpi_sub_masters.length >= 5) {
            if (
              this.kpi[item.kpi_sub_masters[1].id] &&
              this.kpi[item.kpi_sub_masters[2].id] &&
              this.kpi[item.kpi_sub_masters[3].id] &&
              this.kpi[item.kpi_sub_masters[4].id]
            ) {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) 
                  + Number(this.kpi[item.kpi_sub_masters[2].id].kpi_sub_value)
                  + Number(this.kpi[item.kpi_sub_masters[3].id].kpi_sub_value)
                  + Number(this.kpi[item.kpi_sub_masters[4].id].kpi_sub_value)
                  );
            }
          }
        break;
        case "65":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  ((Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) *
                    100) /
                  Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value)).toFixed(2);
              }
            }
          }
          console.log("itemTotal2", itemTotal)
          console.log("item.kpi_sub_masters[0].id]", this.kpi[item.kpi_sub_masters[0].id])
          console.log("item.kpi_sub_masters[1].id]", this.kpi[item.kpi_sub_masters[1].id])
          break;
        // Other Case
        default:
          item.kpi_sub_masters.forEach((sub, index) => {
            if (index !== item.kpi_sub_masters.length - 1 && this.kpi[sub.id]) {
              itemTotal += Number(this.kpi[sub.id].kpi_sub_value);
            }
          });
          break;
      }

      // call setKpiField with the id of the last kpi_sub_master and the calculated itemTotal
      let lastSub = item.kpi_sub_masters[item.kpi_sub_masters.length - 1];
      if (
        lastSub &&
        lastSub.id &&
        (!this.kpi[lastSub.id] ||
          this.kpi[lastSub.id].kpi_sub_value != itemTotal)
      ) {
        this.setKpiField(lastSub.id, itemTotal);
      }

      return itemTotal;
    },
    addAnnexFile() {
      this.annexFiles.push({});
    },
    addToAttachment(index, file) {
      if (file.size > 50000000) {
        this.$store.commit('General/setModal', {
          title: 'ขนาดไฟล์เกิน 50 MB',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        this.annexFiles.pop()
        return
      }
      this.annexFiles[index] = file;
      this.$forceUpdate();
    },
    checkValType(val) {
      return typeof val;
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    removeFile(id) {
      this.annexFiles.splice(id, 1);
      this.$forceUpdate();
    },
    addCompanyList() {
      this.companyList.push({
        participants_year: '',
        participants_count: '',
      })
    },
    addToCompany(index, field, file) {
      this.companyList[index][field] = file
      this.form.completed_incubation_company = this.companyList
      this.$forceUpdate()
    },
    removeCompany(id) {
      console.log('before remove', this.companyList)
      this.companyList.splice(id, 1)
      this.form.completed_incubation_company = this.companyList
      console.log('after remove', this.companyList)
      this.$forceUpdate()
    },
   async syncKpi(id) {
      try {
        const res = await this.$apiFire("CForm/syncKPI", this.syncId);
        if (!res) {
          console.log("syncKPI API ไม่ส่งค่า");
          return;
        }
        this.kpiData = res;
        this.kpiSynced = true;

        // มี kpi_masters จริงไหม?
        if (!Array.isArray(this.masterData?.kpi_masters) || this.masterData.kpi_masters.length === 0) {
          console.log("ไม่มี kpi_masters");
          return;
        }
        // หาตัว master ที่ no = 63 หรือ 69
        const is63 = this.masterData.kpi_masters.findIndex(
          (item) => item?.no === "63"
        );
        const is69 = this.masterData.kpi_masters.findIndex(
          (item) =>  item?.no === "69"
        );
        const index = is63 === -1 ? is69 : is63;
        if (index === -1) {
          console.log("ไม่พบ kpi_masters ที่ no = 63 หรือ 69");
          return;
        }
        const master = this.masterData.kpi_masters[index];
        const tCCLField1 = master?.kpi_sub_masters?.[0];
        const tCCLField2 = master?.kpi_sub_masters?.[5];

        if (!tCCLField1 || !tCCLField2) {
          console.log("ไม่พบ kpi_sub_masters ที่ index 0 หรือ 5");
          return;
        }
        if(is63 !== -1){
          this.setKpiField(tCCLField1.id,  this.kpiData["63.1"] ?? null);
          this.setKpiField(tCCLField2.id,  this.kpiData["63.6"] ?? null);
        }
        if(is69 !== -1){
          this.setKpiField(tCCLField1.id, this.kpiData["69.1"] ?? null);
          this.setKpiField(tCCLField2.id, this.kpiData["69.6"] ?? null);
        }
      } catch (e) {
        console.error("syncKpi error:", e);
      }
    },
    setKpiFieldStyle(itemNo, subNo) {
      if (this.kpiSynced && (itemNo === '63' || itemNo === '69') && (subNo === '63.1' || subNo === '63.6' || subNo === '69.1' || subNo === '69.6')) {
        return 'theme-color-one';
      }
      return 'black--text';
    },
    goToTCCL() {
      if(this.tccl_full_url){
        window.open(this.tccl_full_url, "_blank");
      }
    }
  }
}
</script>

<style lang="scss">
.incubation_companie_form {
  label {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px !important;
    border-radius: 30px;
  }

  .v-text-field--full-width .v-input__prepend-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer {
    margin-top: 8px !important;
  }

  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  i.v-icon.notranslate.mdi.mdi-calendar.theme--light {
    color: #f7941d !important;
  }
}
.potential-link{
  cursor: pointer;
  text-decoration: underline;
  color: var(--theme-color-one);
  font-weight: 500;
}
.potential-link:hover{
  opacity: 0.8;
}
</style>
